import script from "./static-text-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./static-text-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./static-text-setting-ly.vue?vue&type=style&index=0&id=7326fa5a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7326fa5a"]])

export default __exports__